<router-outlet></router-outlet>
<div class="floating-area" *ngIf="showPlusButton">
  <button
    class="menu-button"
    [class.open]="menuOpen"
    [class.bump-up]="windowScrolled"
    (click)="toggleMenu()"
  >
    <i class="material-icons plus-icon">add</i>
    <i class="material-icons close-icon">close</i>
  </button>

  <div
    class="items-wrapper"
    *ngIf="menuOpen"
    [style.bottom]="itemsBottomPosition"
  >
    <!-- Add Task -->
    <ng-container *renderIf="{ roles: ['employee'], right: 'H1026' }">
      <div class="item">
        <button class="action-button" routerLink="/i-team/tasks/add">
          <img src="/assets/images/icons/home/task.svg" />
        </button>
        <span class="label">Add Task</span>
      </div>
    </ng-container>

    <!-- View Leads -->
    <ng-container *renderIf="{ roles: ['employee'], right: 'I1015' }">
      <div class="item">
        <button class="action-button" (click)="navigateTo(leadURL)">
          <img src="/assets/images/icons/home/lead.svg" />
        </button>
        <span class="label">View Leads</span>
      </div>
    </ng-container>

    <!-- Add PR -->
    <ng-container *renderIf="{ roles: ['employee'], right: 'A1023' }">
      <div class="item">
        <button class="action-button" (click)="navigateTo(inventoryURL)">
          <img src="/assets/images/icons/home/pr.svg" />
        </button>
        <span class="label">Add PR</span>
      </div>
    </ng-container>

    <!-- Add Employee -->
    <ng-container *renderIf="{ roles: ['employee'], right: 'F1007' }">
      <div class="item">
        <button class="action-button" routerLink="/hr360/employees/all/add">
          <img src="/assets/images/icons/home/profile.svg" />
        </button>
        <span class="label">Add Employee</span>
      </div>
    </ng-container>

    <!-- Chat -->
    <ng-container *renderIf="{ roles: ['employee'], right: 'B' }">
      <div class="item">
        <button class="action-button" routerLink="/app/chat">
          <img src="/assets/images/icons/home/chat.svg" />
        </button>
        <span class="label">Chat</span>
      </div>
    </ng-container>
  </div>
</div>
